import { Route, RouteConfig } from 'vue-router';
import { PagePermissionEnum } from '@/types/enum/PermissionEnum';

const projectRoute = [
	{
		path: '/projets',
		name: 'projects',
		component: () => import(
			/* webpackChunkName: "project_list" */
			'../../views/ProjectList.vue'
		),
		meta: {
			can: 'projects_list',
			label: 'router.label.projects',
			hiddenOnProjectRoute: true
		}
	},
	{
		path: '/projet/:projectToken',
		name: 'project',
		props: true,
		component: () => import(
			/* webpackChunkName: "project" */
			'../../views/ProjectView.vue'
		),
		meta: {
			can: () => {
				return true;
			},
			label: 'router.label.project',
			orderProperty: 0
		}
	},
	{
		path: '/projet/:projectToken/gestion-des-utilisateurs',
		name: 'users',
		props: true,
		component: () => import(
			/* webpackChunkName: "users" */
			'../../views/Users.vue'
		),
		meta: {
			can: (to: Route, from: Route, can: any) => {
				return can(PagePermissionEnum.PROJECT, {
					token: to.params.projectToken,
					type: 'Project'
				});
			},
			navigationConfigurationName: 'filter-user',
			isConfigurationMandatory: true
		}
	},
	{
		path: '/projet/:projectToken/gestion-des-acteurs',
		name: 'actors',
		props: true,
		component: () => import(
			/* webpackChunkName: "actors" */
			'../../views/ActorsView.vue'
		),
		meta: {
			can: (to: Route, from: Route, can: any) => {
				return (can(PagePermissionEnum.ACTORS_LIST, {
					token: to.params.projectToken,
					type: 'Project'
				}));
			},
			navigationConfigurationName: 'list-actor',
			isConfigurationMandatory: true
		}
	},
	{
		path: '/projet/:projectToken/convention',
		name: 'usersActors',
		props: route => ({
			type: 'convention',
			projectToken: route.params.projectToken
		}),
		component: () => import(
			/* webpackChunkName: "users-actors" */
			'../../views/UsersActorsView.vue'
			),
		meta: {
			can: (to: Route, from: Route, can: any) => {
				return (can(PagePermissionEnum.USERS_ACTORS_LIST, {
					token: to.params.projectToken,
					type: 'Project'
				}));
			},
			params: {
				type: 'convention'
			},
			navigationConfigurationName: 'link-user-actor',
			isConfigurationMandatory: true
		}
	},
	{
		path: '/projet/:projectToken/gestion-des-utilisateurs-acteurs',
		name: 'idelActors',
		props: route => ({
			type: 'idel',
			projectToken: route.params.projectToken
		}),
		component: () => import(
			/* webpackChunkName: "idel-actors" */
			'../../views/UsersActorsView.vue'
			),
		meta: {
			can: (to: Route, from: Route, can: any) => {
				return (can(PagePermissionEnum.IDEL_ACTORS_LIST, {
					token: to.params.projectToken,
					type: 'Project'
				}));
			},
			params: {
				type: 'idel'
			},
			navigationConfigurationName: 'add-idel-actor',
			isConfigurationMandatory: true
		}
	},
	{
		path: '/projet/:projectToken/paiements',
		name: 'paymentsByProject',
		props: true,
		component: () => import(
			/* webpackChunkName: "payments_by_project" */
			'../../views/PaymentsByProject.vue'
		),
		meta: {
			can: (to: Route, from: Route, can: any) => {
				return (can(PagePermissionEnum.PROJECT_PAYMENTS_LIST, {
					token: to.params.projectToken,
					type: 'Project'
				}));
			},
			navigationConfigurationName: 'list-payment',
			isConfigurationMandatory: true
		}
	},
	{
		path: '/projet/:projectToken/exports',
		name: 'exportsByProject',
		props: true,
		component: () => import(
			/* webpackChunkName: "exports_by_project" */
			'../../views/ExportsByProject.vue'
		),
		meta: {
			can: (to: Route, from: Route, can: any) => {
				return (can(PagePermissionEnum.PROJECT_EXPORTS_LIST, {
					token: to.params.projectToken,
					type: 'Project'
				}));
			},
			navigationConfigurationName: 'list-export',
			isConfigurationMandatory: true
		}
	},
	{
		path: '/projet/:projectToken/exports-payment',
		name: 'exportsPaymentList',
		props: true,
		component: () => import(
			/* webpackChunkName: "exports_by_project" */
			'../../views/ExportsPayment.vue'
		),
		meta: {
			can: (to: Route, from: Route, can: any) => {
				return (can(PagePermissionEnum.EXPORTS_PAYMENT, {
					token: to.params.projectToken,
					type: 'Project'
				}));
			},
			navigationConfigurationName: 'list-export-payment',
			isConfigurationMandatory: true
		}
	},
	{
		path: '/projet/:projectToken/experience-patient',
		name: 'surveyCampaigns',
		props: true,
		component: () => import(
			/* webpackChunkName: "survey_campaign" */
			'../../views/SurveyCampaignsView.vue'
		),
		meta: {
			can: (to: Route, from: Route, can: any) => {
				return (can(PagePermissionEnum.SURVEY_CAMPAIGN, {
					token: to.params.projectToken,
					type: 'Project'
				}));
			},
			navigationConfigurationName: 'survey-campaign',
			isConfigurationMandatory: true
		}
	},
	{
		path: '/projet/:projectToken/experience-patient/:surveyCampaignReference',
		name: 'surveyCampaign',
		props: true,
		component: () => import(
			/* webpackChunkName: "survey_campaign" */
			'../../views/SurveyCampaignsView.vue'
		),
		meta: {
			can: (to: Route, from: Route, can: any) => {
				return (can(PagePermissionEnum.SURVEY_CAMPAIGN, {
					token: to.params.projectToken,
					type: 'Project'
				}));
			},
			navigationConfigurationName: 'survey-campaign',
			isConfigurationMandatory: true
		}
	}
] as RouteConfig[];

export default projectRoute;
